import { useEffect } from "react";

export function usePlayerPresence(setPlayer) {
  useEffect(() => {
    const setPlayerActiveState = (active) => {
      setPlayer((previousPlayer) => {
        if (!previousPlayer || previousPlayer.active === active) {
          return previousPlayer;
        }

        return {
          ...previousPlayer,
          active,
        };
      });
    };

    const markPlayerActive = () => {
      setPlayerActiveState(true);
    };

    const markPlayerInactive = () => {
      setPlayerActiveState(false);
    };

    const handleVisibilityChange = () => {
      setPlayerActiveState(document.visibilityState !== "hidden");
    };

    const handleBeforeUnload = (event) => {
      markPlayerInactive();
      event.preventDefault();
      event.returnValue = "";
    };

    markPlayerActive();

    window.addEventListener("focus", markPlayerActive);
    window.addEventListener("pageshow", markPlayerActive);
    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("pagehide", markPlayerInactive);

    return () => {
      window.removeEventListener("focus", markPlayerActive);
      window.removeEventListener("pageshow", markPlayerActive);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("pagehide", markPlayerInactive);
    };
  }, [setPlayer]);
}
